<script>
    import moment from 'moment'

    export default {
        name: 'CurrentTime',
        props: {
            agendaStart: {
                type: Number,
                default: 0,
            },
            agendaDuration: {
                type: Number,
                default: 24,
            },
        },
        data() {
            return {
                interval: null,
                topTime: 0,
                show: false
            }
        },
        beforeUnmount() {
            // prevent memory leak
            clearInterval(this.interval)
        },
        created() {
            this.interval = setInterval(() => {
                const time = moment().format('HH:mm');
                const timeArray = time.toString().split(':');
                const minutes = ((+timeArray[0]) * 60 + (+timeArray[1]));
                
                this.topTime = '' + parseFloat((minutes - this.agendaStart * 60) * 100 / (this.agendaDuration * 60)).toFixed(2)

                const current = moment().format('HH');
                if(current > this.agendaStart
                    && current < (this.agendaStart + this.agendaDuration)) {
                    this.show = true;
                } else {
                    this.show = false;
                }
            }, 1000)
        },
    }
</script>

<template>
    <div v-show="show" class="absolute w-full h-0 z-[999]" :style="{top: topTime + '%'}">
        <div class="absolute h-[10px] z-[999] flex">
            <div class="bg-[red] w-[10px] h-[10px] mb-[2px] z-[999] block right-0"></div>
            <div class="w-0 h-0
                border-t-[5px] border-t-transparent
                border-b-[5px] border-b-transparent
                border-l-[5px] border-[red]"></div>
        </div>
        <div class="bg-[red] h-[1px] mt-1 mb-1"></div>
    </div>
</template>
